<div class="sk-cms-search-wap sk-cms-search-get"
     {{if style.background.styleType != 'default'}}
       {{if style.background.backgroundType == 'color'}}
         style="background-color:{{style.background.color}}"
       {{/if}}
       {{if style.background.backgroundType == 'img'}}
         style="background-image:url('{{style.background.imgUrl}}')"
       {{/if}}
     {{/if}}

>
  {{if style.isShowTitle == '1'}}
  <% include('../common/title.art', {title: basic.title, terminal: 'title-wap'}) %>
  {{/if}}
  <a href="{{isPreview ? content.moreLink: content.morePage}}">
  <div class="content">
      <div class="input-box"
           style="{{style.placeholder.model == 'default' ? '': 'color:' + style.placeholder.color}};
            {{style.searchBox.model == 'default' ? '': 'border-color:' + style.searchBox.color}};
            {{style.searchBox.model == 'default' ? '': 'background-color:' + style.searchBox.color2}};
          "
      >
        {{content.placeholder}}
      </div>
    {{if style.searchButton.styleType != 'hide'}}
      <div class="button"
           style="{{style.searchButton.styleType == 'default' ? '': 'background-color:' + style.searchButton.backgroundColor}};
                 {{style.searchButton.styleType == 'default' ? '': 'color:' + style.searchButton.color}};
                {{style.searchButton.styleType == 'default' ? '': 'background-image: url(' + style.searchButton.imgUrl + ')'}};
                 "
      >
        {{if content.type == 'text'}}
        <span>{{content.buttonText}}</span>
        {{else}}
        <span class="smarket icons-sousuo"></span>
        {{/if}}
      </div>
    {{/if}}
  </div>
  </a>
</div>